import { useCallback } from 'react';

import type { CoopContentPageSize } from '../../../utility/coopSwiperBreakpoints';

import { sharedUiActions } from '../store/slices/ui/sharedUiSlice';
import { useAppDispatch, useAppSelector } from './useThunkDispatch';

export const useLayoutSize = () => {
    const layoutSize = useAppSelector((state) => state.ui.shared.layoutSize);
    const dispatch = useAppDispatch();

    const setContentPageSize = useCallback(
        (size: CoopContentPageSize) => {
            dispatch(sharedUiActions.setContentPageSize({ size: size || layoutSize }));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [dispatch],
    );

    return { layoutSize, setContentPageSize };
};
